import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import moment from "moment";
import { ActivatedRoute } from "@angular/router";
import { ValidationService } from "src/app/services/validation.service";
import { clearConfig } from "dompurify";
import * as Constants from "../../../../constant/Constants";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { MatDialog } from "@angular/material/dialog";
import { ApiCallService } from "src/app/api/service/api-call.service";
import { environment } from "src/environments/environment";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { CurrencyPipe } from "@angular/common";
import { Router } from '@angular/router';

@Component({
  selector: 'app-theft-details',
  templateUrl: './theft-details.component.html',
  styleUrls: ['./theft-details.component.css']
})
export class TheftDetailsComponent implements OnInit {
  // Url Params
  type: string = "total"; // [total, partial]
  replaced: string = 'false';
  id: string = "none";
  token: string = "placeholder-value"; // to validate the public accesses.

  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  pageHeading: string = "Total Loss - Theft Claim Form (Continued)";
  policeSubHeading: string = "Police Details";
  policeDateLabel: string = "Police date";
  policeDateHint: string = "Date you reported theft to police";
  crObNumberLabel: string = "Criminal register/OB number";
  policeStationLabel: string = "Police station address/ police station name";

  vehicleDetailsSubHeading: string = "Vehicle Details";
  alterationsQuestion: string = "Have you had any alterations made which are recognisable?";
  fitmentsQuestion: string = "Are there any special fitments or accessories?";
  identifiersQuestion: string = "Are there any identifying features, externally or internally, e.g. Marks, scratches, disfigurements etc?";
  giveDetailsLabel: string = "Please give details";
  mileageLabel: string = "Mileage reading at the time of loss (Approx)";

  partsDetailsSubHeading: string = "Parts Details";
  partDescLabel: string = "Part Description";
  pricePaidLabel: string = "Price Paid";
  dealerLabel: string = "Dealer from whom the part was purchased";
  purchaseDateLabel: string = "Date of Purchase";
  claimedAmountLabel: string = "Amount Claimed";
  moreStolenPartsText: string = "List more stolen parts";
  remove: string = 'Remove';

  previousClaimsLabel: string = "Previous claims";
  otherInsurancesQuestion: string = "Are there any other insurances against Burglary or Theft upon the same vehicle?";
  previousTheftsQuestion: string = "Have you had any vehicle stolen on previous occasions?";
  previousTheftsLabel: string = "Please give details of previous thefts";
  insuranceCompanyLabel: string = "Insurance company details";
  insuranceCompanyHint: string = "Insurance company that had insured the vehicle";
  previousClaimDateLabel: string = "Previous claim date";

  nameLabel: string = "Your Full Name";
  dateLabel: string = "Date";
  iSwearText: string = 'I hereby declare that these particulars are true, and undertake to forward immediately (if any, unanswered), correspondence relating to this accident.';


  yesText: string = "Yes";
  noText: string = "No";

  cancelText: string = "Cancel";
  saveText: string = "Save and Continue";
  requiredString: string = 'This field is required';

  namePlaceHolder: string = '';


  motorForm = this._formBuilder.group({
    policeDate: [moment(null), Validators.required],
    crObNumber: ["", Validators.required],
    policeStation: ["", Validators.required],

    alterations: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    alterationDetails: ["", Validators.required],
    fitments: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    fitmentDetails: ["", Validators.required],
    identifiers: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    identifierDetails: ["", Validators.required],
    mileage: ["", Validators.required],

    partDetails: this._formBuilder.array([]),

    otherInsurances: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    previousThefts: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    previousTheftDetails: [""],
    insuranceCompany: [""],
    previousClaimDate: [""],
    name: ["", [Validators.required, Validators.pattern(/^.+ .+/)]],
    date: [moment(), Validators.required],
    iSwear: [false],
  });

  formErrors:{[key:string]:string} ={
    policeDate:'',
    crObNumber:'',
    policeStation:'',
    alterationDetails:'',
    fitmentDetails:'',
    identifierDetails:'',
    mileage:'',
    partDetails:'',
    previousTheftDetails:'',
    insuranceCompany:'',
    previousClaimDate:'',
    name:'',
    date:'',
    partDesc:'',
    pricePaid:'',
    dealer:'',
    purchaseDate:'',
    claimedAmount:'',
  }
  formGroupErrors: { [key: string]: string } = {
    alterations:'',
    fitments:'',
    identifiers:'',
    otherInsurances:'',
    previousThefts:'',
  };

  validationMessages:{[key:string]:{[key:string]:string}} ={
    policeDate: {required: this.requiredString },
    crObNumber: {required: this.requiredString },
    policeStation: {required: this.requiredString },
    alterations: {required: this.requiredString },
    alterationDetails: {required: this.requiredString },
    fitments: {required: this.requiredString },
    fitmentDetails: {required: this.requiredString },
    identifiers: {required: this.requiredString },
    identifierDetails: {required: this.requiredString },
    mileage: {required: this.requiredString },
    partDetails: {required: this.requiredString },
    otherInsurances: {required: this.requiredString },
    previousThefts: {required: this.requiredString },
    previousTheftDetails: {required: this.requiredString },
    insuranceCompany: {required: this.requiredString },
    previousClaimDate: {required: this.requiredString },
    name: {required: this.requiredString, pattern: 'Please enter your Full Name' },
    date: {required: this.requiredString },
    partDesc: {required: this.requiredString },
    pricePaid: {required: this.requiredString },
    dealer: {required: this.requiredString },
    purchaseDate: {required: this.requiredString },
    claimedAmount: {required: this.requiredString },
  }


  minDate: Date;
  maxDate: Date;
  minPurchaseDate: Date;
  minPoliceDate: Date;
  url: string = environment.baseUrl + Constants.claimExtraDetailsURL;
  loading: boolean = false;

  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private validationService: ValidationService,
    private apiCallService: ApiCallService,
    private currencyPipe: CurrencyPipe,
    public dialog: MatDialog
  ) {
    const currentDate = new Date();
    const tempDate = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 10);

    this.minDate = tempDate;
    this.maxDate = currentDate;
    this.minPoliceDate = tempDate;
    this.minPurchaseDate = tempDate;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;

      if (params['replaced'] !== undefined) {
        this.replaced = params['replaced'];
      }
      
      if (params['type'] !== undefined) {
        this.type = params['type'];

        if (params['type'] === 'partial') {
          this.pageHeading = 'Partial Theft Claim Form (Continued)';
          this.addNewPart();

          this.motorForm.controls["alterations"].setErrors(null);
          this.motorForm.controls["alterationDetails"].setErrors(null);
          this.motorForm.controls["fitments"].setErrors(null);
          this.motorForm.controls["fitmentDetails"].setErrors(null);
          this.motorForm.controls["identifiers"].setErrors(null);
          this.motorForm.controls["identifierDetails"].setErrors(null);
          this.motorForm.controls["mileage"].setErrors(null);

        } else if (params['type'] === 'total') {
          this.motorForm.controls["partDetails"].setErrors(null);
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("alterations.yes")!,
            "alterationDetails",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("fitments.yes")!,
            "fitmentDetails",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("identifiers.yes")!,
            "identifierDetails",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );

          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("previousThefts.yes")!,
            "previousTheftDetails",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("previousThefts.yes")!,
            "insuranceCompany",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("previousThefts.yes")!,
            "previousClaimDate",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
        }
      }
      if (params['id'] !== undefined) {
        this.id = params['id'];
        this.getPolicyDetails();
      }

    });

    this.motorForm.valueChanges.subscribe((form)=>{
      this.logErrors()
      
      if (this.type === 'partial' && form.partDetails) {
        const partDetails = this.motorForm.get('partDetails') as FormArray;
        
        partDetails.controls.forEach(control => {
          const pricePaid = control.get('pricePaid');
          if (!(pricePaid === null || pricePaid.value === '')) {
            control.patchValue({
              pricePaid: this.currencyPipe.transform(pricePaid.value.replace(/\D/g, '').replace(/^0+/, ''), 'KES  ', 'symbol', '1.0-0')
            }, {emitEvent: false});
          }

          const claimedAmount = control.get('claimedAmount');
          if (!(claimedAmount === null || claimedAmount.value === '')) {
            control.patchValue({
              claimedAmount: this.currencyPipe.transform(claimedAmount.value.replace(/\D/g, '').replace(/^0+/, ''), 'KES  ', 'symbol', '1.0-0')
            }, {emitEvent: false});
          }

          const dealer = control.get('dealer');
          if (!(dealer === null || dealer.value === '')) {
            control.patchValue({
              dealer: dealer.value.replace(/[a-z]/g, (match: string) => match.toUpperCase())
            }, {emitEvent: false});
          }

          const partDesc = control.get('partDesc');
          if (!(partDesc === null || partDesc.value === '')) {
            control.patchValue({
              partDesc: partDesc.value.replace(/[a-z]/g, (match: string) => match.toUpperCase())
            }, {emitEvent: false});
          }
        })
      }

      if (form.crObNumber) {
        this.motorForm.patchValue({
          crObNumber: form.crObNumber.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.mileage) {
        this.motorForm.patchValue({
          mileage: form.mileage.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (form.insuranceCompany) {
        this.motorForm.patchValue({
          insuranceCompany: form.insuranceCompany.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.name) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          name: form.name.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.alterations?.no) {
        this.motorForm.controls["alterationDetails"].setErrors(null);
      }
      if (form.fitments?.no) {
        this.motorForm.controls["fitmentDetails"].setErrors(null);
      }
      if (form.identifiers?.no) {
        this.motorForm.controls["identifierDetails"].setErrors(null);
      }
      if (form.previousThefts?.no) {
        this.motorForm.controls["insuranceCompany"].setErrors(null);
        this.motorForm.controls["previousTheftDetails"].setErrors(null);
        this.motorForm.controls["previousClaimDate"].setErrors(null);
      }
      if (this.type === 'partial' && this.motorForm.controls['mileage'].untouched) {
        this.motorForm.controls["mileage"].setErrors(null);
      }
    })
  }

  async getPolicyDetails() {
    try {
      const dat = {
        id: this.id
      };
      const response = await this.apiCallService.postRequest(
        environment.baseUrl + Constants.policyDetailsURL, dat);

      if (response.error) {
        console.log(':Get details ERROR :: ', response);
      } else {
        this.namePlaceHolder = response.body.name;
        this.motorForm.get('name')?.setValue(this.namePlaceHolder);
      }
    } catch (error) {
      console.log(':Details ERROR !! :: ', error);
    }
  }

  createPartsFormGroup(): FormGroup {
    if (this.replaced === 'true') {
      return this._formBuilder.group({
        partDesc: ['', Validators.required],
        pricePaid: ['', Validators.required],
        dealer: ['', Validators.required],
        purchaseDate: ['', Validators.required],
        claimedAmount: [''],
      });
    }
    return this._formBuilder.group({
      partDesc: ['', Validators.required],
      claimedAmount: [''],
    });
  };

  addNewPart() {
    const fields = this.motorForm.get('partDetails') as FormArray;
    fields.push(this.createPartsFormGroup());
    this.motorForm.setControl('partDetails', fields);
  }

  removePart(i:number) {
    const fields = this.motorForm.get('partDetails') as FormArray;
    fields.removeAt(i);  
  }

  getParts() : FormArray {  
    return this.motorForm.get("partDetails") as FormArray  
  }

  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  onYesChange() {
    this.motorForm.controls["alterations"].controls["no"].setValue(false);
  }

  onNoChange() {
    this.motorForm.controls["alterations"].controls["yes"].setValue(false);
    this.motorForm.controls["alterationDetails"].setErrors(null);
  }

  onYes2Change() {
    this.motorForm.controls["fitments"].controls["no"].setValue(false);
  }

  onNo2Change() {
    this.motorForm.controls["fitments"].controls["yes"].setValue(false);
    this.motorForm.controls["fitmentDetails"].setErrors(null);
  }

  onYes3Change() {
    this.motorForm.controls["identifiers"].controls["no"].setValue(false);
  }

  onNo3Change() {
    this.motorForm.controls["identifiers"].controls["yes"].setValue(false);
    this.motorForm.controls["identifierDetails"].setErrors(null);
  }

  onYes4Change() {
    this.motorForm.controls["otherInsurances"].controls["no"].setValue(false);
  }

  onNo4Change() {
    this.motorForm.controls["otherInsurances"].controls["yes"].setValue(false);
  }

  onYes5Change() {
    this.motorForm.controls["previousThefts"].controls["no"].setValue(false);
  }

  onNo5Change() {
    this.motorForm.controls["previousThefts"].controls["yes"].setValue(false);
    this.motorForm.controls["previousTheftDetails"].setErrors(null);
  }

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      policeDate: this.motorForm.controls["policeDate"].value,
      crObNumber: this.motorForm.controls["crObNumber"].value,
      policeStation: this.motorForm.controls["policeStation"].value,

      alterations: this.type === 'total' ? this.motorForm.controls["alterations"].value : null,
      alterationDetails: this.motorForm.controls["alterations"].controls["yes"].value === true ? this.motorForm.controls["alterationDetails"].value : null,
      fitments: this.type === 'total' ? this.motorForm.controls["fitments"].value : null,
      fitmentDetails: this.motorForm.controls["fitments"].controls["yes"].value === true ? this.motorForm.controls["fitmentDetails"].value : null,
      identifiers: this.type === 'total' ? this.motorForm.controls["identifiers"].value : null,
      identifierDetails: this.motorForm.controls["identifiers"].controls["yes"].value === true ? this.motorForm.controls["identifierDetails"].value : null,
      mileage: this.motorForm.controls["mileage"].touched ? this.motorForm.controls["mileage"].value : null,

      partDetails: this.motorForm.controls["partDetails"].value,
      otherInsurances: this.motorForm.controls["otherInsurances"].value,
      previousThefts: this.motorForm.controls["previousThefts"].value,
      previousTheftDetails: this.motorForm.controls["previousTheftDetails"].value,
      insuranceCompany: this.motorForm.controls["insuranceCompany"].value,
      previousClaimDate: this.motorForm.controls["previousClaimDate"].value,
      name: this.motorForm.controls["name"].value,
      date: this.motorForm.controls["date"].value,
      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }

}
